import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'moreInfo',
  'author',
  'year',
  'citation',
  'ok',
  'have',
  'comments',
]);

export const sort = fromJS([
  { id: 'year', asc: true },
  { id: 'id', asc: true },
]);

export const minColumns = fromJS([]);
